
import React, { useState, useEffect, useRef } from "react";
import { API_BASE_URL } from "../../config/apiConfig";


export default function ParticipantAutocomplete({ onSelect, onDeleteParticipant, clearQuery, onClearQueryHandled }) {
  const [query, setQuery] = useState("");
  const [allParticipants, setAllParticipants] = useState([]);
  const [results, setResults] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const inputRef = useRef();


  // Permitir limpiar el input desde el padre
  useEffect(() => {
    if (clearQuery) {
      setQuery("");
      setResults([]);
      setShow(false);
      if (onClearQueryHandled) onClearQueryHandled();
    }
  }, [clearQuery, onClearQueryHandled]);

  useEffect(() => {
    // Cargar todos los participantes al montar
    setLoading(true);
    fetch(`${API_BASE_URL}/obtener_participantes_ranking.php`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setAllParticipants(data.participantes || []);
        } else {
          setError(data.message || "Error al cargar participantes");
        }
      })
      .catch(() => setError("Error de red al cargar participantes"))
      .finally(() => setLoading(false));
  }, []);

  // Si se elimina un participante, bórralo del array local
  useEffect(() => {
    if (onDeleteParticipant) {
      setAllParticipants(prev => prev.filter(p => p.id !== onDeleteParticipant));
      setResults(prev => prev.filter(p => p.id !== onDeleteParticipant));
    }
  }, [onDeleteParticipant]);

  const handleChange = (e) => {
    const val = e.target.value;
    setQuery(val);
    if (val.length > 0) {
      const filtered = allParticipants.filter(p => p.nombre.toLowerCase().includes(val.toLowerCase()));
      setResults(filtered);
      setShow(true);
    } else {
      setResults([]);
      setShow(false);
    }
    onSelect(null);
  };

  const handleSelect = (p) => {
    setQuery(p.nombre);
    setShow(false);
    onSelect(p);
  };

  // Cerrar dropdown al hacer click fuera
  useEffect(() => {
    const handleClick = (e) => {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div className="relative" ref={inputRef}>
      <input
        type="text"
        className="w-full rounded-lg bg-gray-900 text-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary transition"
        placeholder={loading ? "Cargando participantes..." : "Buscar participante..."}
        value={query}
        onChange={handleChange}
        onFocus={() => query && setShow(true)}
        autoComplete="off"
        disabled={loading}
      />
      {error && <div className="text-red-500 text-xs mt-1">{error}</div>}
      {show && results.length > 0 && (
           <ul className="absolute z-50 left-0 right-0 mt-1 bg-gray-800 rounded-lg shadow-lg max-h-56 overflow-auto border border-primary/30">
          {results.map((p, i) => (
            <li
              key={p.id || i}
              className="px-4 py-2 cursor-pointer hover:bg-primary/20 transition flex items-center gap-2"
              onClick={() => handleSelect(p)}
            >
              {p.imagen ? (
                <img src={p.imagen} alt="" className="w-6 h-6 rounded-full object-cover" />
              ) : (
                <span className="inline-block w-6 h-6 rounded-full bg-gray-700" />
              )}
              <span>{p.nombre}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
